import { useTranslation } from "react-i18next"
import { Status } from "../../../../../../../../../utils/enums"
import { Item } from "../../../../../../../../../utils/types/generals"
import { MenuOptions } from "../enums"
import { useEffect, useState } from "react"

export const useMenu = ({ status, option }: { status: Status; option: { canDelete: boolean; geofence?: boolean; locationOn: boolean, isTheUserAssigned?: boolean } }) => {
    const { t } = useTranslation()
    const deleteItem = { label: t('general.delete'), value: MenuOptions.DELETE }
    const editItem = { label: t('general.edit'), value: MenuOptions.EDIT }
    const resendReportItem = { label: t('general.resendReport'), value: MenuOptions.RESEND_INFORM }
    const reScheduleItem = { label: t('general.reSchedule'), value: MenuOptions.RESCHEDULE }
    const forceClosureItem = { label: t('general.forceClosure'), value: MenuOptions.FORCE_CLOSURE }
    const cancelActivityItem = { label: t('general.cancelActivity'), value: MenuOptions.CANCEL_ACTIVITY }
    const seeReportItem = { label: t('general.seeReport2'), value: MenuOptions.SEE_INFORM }
    const optionMenu = {
        [Status.FINISHED]: [seeReportItem, resendReportItem],
        [Status.NOT_FINISHED]: [seeReportItem, resendReportItem],
        [Status.EXPIRED]: [seeReportItem, resendReportItem],
        [Status.CANCEL]: [seeReportItem, deleteItem],
        [Status.TO_BE_STARTED]: [editItem, deleteItem, reScheduleItem, cancelActivityItem, seeReportItem],
        [Status.STARTED]: [ deleteItem, reScheduleItem, forceClosureItem, cancelActivityItem, seeReportItem],
    } as Record<Status, Item[]>
    const [menuByStatus, setMenuByStatus] = useState<Item[]>([])
    useEffect(() => {
        setMenuByStatus(optionMenu[status]?.filter(menu => {
            if ([MenuOptions.DELETE, MenuOptions.CANCEL_ACTIVITY].includes(menu.value) && !option.canDelete) { return false }
            if ([MenuOptions.FORCE_CLOSURE].includes(menu.value) && ( (!option.locationOn) || (!option.isTheUserAssigned) ) ) { return false }
            if ([MenuOptions.RESCHEDULE].includes(menu.value) && ( (option.geofence) || (!option.canDelete) ) ) { return false }
            return true
        }))
    }, [option.canDelete, status, option.locationOn, option.geofence])
    return menuByStatus
}